import type { PersonDto } from "../../../autogen/bff-api";

export const personName = (person: PersonDto): string =>
  [person.firstName, person.lastName].filter(Boolean).join(" ").trim() || person.email;

export const formatDateTime = (iso: string, locale = "nb-NO"): string => {
  if (!iso) return "";
  const date = new Date(iso);
  if (isNaN(date.getTime())) return iso;
  return date.toLocaleString(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const richTextHasContent = (html: string): boolean =>
  html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim().length > 0;
